import {BarCode} from './BarCode';
export default BarCode;